<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col handset-center-login">
      @if (!isHandset) {
        <div class="row">
          <div class="col text-center">
            <h1
              class="text-white mb-5"
            [innerHTML]="'login.welcome_text' | transloco"></h1>
          </div>
        </div>
      }
      <div class="row" [ngClass]="{ 'h-100': isHandset }">
        <div
          class="col text-center"
          [ngClass]="{ 'handset-center-login': isHandset }">
          <mat-card class="login-card d-inline-block">
            <mat-card-header class="login-header">
              <mat-icon
                class="mb-3"
                svgIcon="logo-square"
              [style]="{ height: '100px', width: '100px' }"></mat-icon>
              @if (!isHandset) {
                <h1 class="login-text">
                  {{ "operations.login" | transloco }}
                </h1>
              }
            </mat-card-header>
            <mat-card-content>
              <form
                [formRoot]="loginForm"
                (keyup.enter)="login()">
                <mat-form-field class="loren-form-field">
                  <mat-label>{{ "login.username" | transloco }}</mat-label>
                  <input
                    matInput
                    [formField]="loginForm.username" />
                </mat-form-field>
                <mat-form-field class="loren-form-field">
                  <mat-label>{{ "login.password" | transloco }}</mat-label>
                  <input
                    matInput
                    [formField]="loginForm.password"
                    type="password" />
                </mat-form-field>
                @if (loginFailureMessageKey()) {
                  <div class="text-danger">
                    {{ loginFailureMessageKey() | transloco }}
                  </div>
                }
              </form>
              <mat-checkbox class="float-left mb-3" [formField]="loginForm.rememberMe">
                {{ "operations.remember_me" | transloco }}
              </mat-checkbox>
              <div class="w-100 text-center">
                <button matButton="filled"
                  class="w-100 text-white m-0"
                  [disabled]="submitting()"
                  (click)="login()">
                  {{ "operations.login" | transloco }}
                </button>
              </div>
              <div class="w-100 text-center mt-3">
                <a
                  class="mt-3 text-black-50"
                  href="#"
                  [routerLink]="['/forgotten-password']"
                  >{{ "features.forgotten_password" | transloco }}?</a
                  >
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="funding-badges">
    <img src="/eu-funded.svg" width="1020" height="214" alt="Съфинансирано от Европейския съюз" />
    <img class="pkip" src="/pkip.webp" width="1536" height="576" alt="Програма Конкурентоспособност и иновации в предприятията" />
  </div>
